import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../../../../_common/application/ts/Glob';
import * as Config from '../config';
import { IValuesCollection } from '../../../../_common/platform/ts/appTheme';

const Globalize = require('pdc-platform-Globalize');

import DataGrid, {
    Column,
    //MasterDetail,
    SearchPanel,
    FilterRow,
    Selection,
    GroupPanel,
    ColumnChooser,
    Summary
} from 'devextreme-react/data-grid';

import ArrayStore from 'devextreme/data/array_store';

function GridPreview(props: { theme: IValuesCollection; glob: IGlob }) {
    const rowAlternationEnabled = props.theme['widget-treelist-row-alternation'];
    const showRowLines = props.theme['widget-treelist-show-row-lines'];
    const showColumnLines = props.theme['widget-treelist-show-column-lines'];
    const showColumnHeaders = props.theme['widget-treelist-show-column-headers'];
    const hoverStateEnabled = props.theme['widget-treelist-hover-enabled'];
    //const wordWrapEnabled = props.theme[Config.themeFields.wordWrapEnabled];
    const allowGrouping = props.theme[Config.themeFields.allowGrouping];
    //const filterRow = props.theme[Config.themeFields.filterRowEnabled];
    const showSearchPanel = props.theme['widget-treelist-show-search'];
    const searchPaneWidth = props.theme['widget-treelist-search-panel-width'];
    const showColumnChooser = props.theme['widget-treelist-column-chooser-show'];
    const columnChooserMode = props.theme['widget-treelist-column-chooser-mode'];

    React.useEffect(() => {}, [
        rowAlternationEnabled,
        showRowLines,
        showColumnLines,
        showColumnHeaders,
        hoverStateEnabled,
        //wordWrapEnabled,
        allowGrouping,
        //filterRow,
        showSearchPanel,
        searchPaneWidth,
        showColumnChooser,
        columnChooserMode
    ]);

    const getDataSource = () => {
        return new ArrayStore({
            key: 'ID',
            data: [
                {
                    ID: 1,
                    OrderNumber: 35703,
                    OrderDate: '2014/02/13',
                    SaleAmount: 11800,
                    Employee: 'Harv Mudd'
                },
                {
                    ID: 4,
                    OrderNumber: 35711,
                    OrderDate: '2014/03/21',
                    SaleAmount: 16050,
                    Employee: 'Jim Packard'
                },
                {
                    ID: 5,
                    OrderNumber: 35714,
                    OrderDate: '2014/04/19',
                    SaleAmount: 14750,
                    Employee: 'Harv Mudd'
                },
                {
                    ID: 7,
                    OrderNumber: 35983,
                    OrderDate: '2014/01/12',
                    SaleAmount: 3725,
                    Employee: 'Todd Hoffman di Van der Gogg'
                }
            ]
        });
    };

    //<FilterRow visible={filterRow} />
    return (
        <div id="gridContainer">
            <DataGrid
                dataSource={getDataSource()}
                rowAlternationEnabled={rowAlternationEnabled}
                showRowLines={showRowLines}
                showColumnLines={showColumnLines}
                showColumnHeaders={showColumnHeaders}
                hoverStateEnabled={hoverStateEnabled}
                //wordWrapEnabled={wordWrapEnabled}
            >
                <Column dataField={'OrderNumber'} width={70} caption={'Invoice'} />
                <Column dataField={'OrderDate'} dataType={'date'} width={135} />
                <Column dataField={'Employee'} />
                <Column dataField={'SaleAmount'} alignment={'right'} format={'currency'} />
                <Selection mode="single" />
                <GroupPanel visible={allowGrouping} />

                <SearchPanel visible={showSearchPanel} width={searchPaneWidth} />
                <ColumnChooser enabled={showColumnChooser} mode={columnChooserMode} />
                <Summary
                    totalItems={[
                        {
                            column: 'OrderNumber',
                            summaryType: 'count'
                        },
                        {
                            column: 'OrderDate',
                            summaryType: 'min',
                            customizeText(data) {
                                return (
                                    'First: ' +
                                    Globalize.formatDate(data.value, {
                                        date: 'short'
                                    })
                                );
                            }
                        },
                        {
                            column: 'SaleAmount',
                            summaryType: 'sum',
                            valueFormat: 'currency'
                        }
                    ]}
                />
            </DataGrid>
        </div>
    );
}

export function ThemePreview(glob: IGlob, theme) {
    var titlePre = 'Grid Widget';

    return [
        <div key="widget" className="widget">
            <div className="widget-inner-container">
                <div className="widget-control-panel">
                    <span>{titlePre}</span>
                    <span className="glyphicon glyphicon-remove remove-button header-button"></span>
                    <span className="glyphicon glyphicon-cog config-button header-button"></span>
                    <span className="glyphicon glyphicon-chevron-down menu-button header-button"></span>
                </div>
                <div className="show-header-button">
                    <span className="glyphicon glyphicon-chevron-down"></span>
                </div>
                <div className="widget-canvas widget-canvas-main">
                    <div className="pdc-widget-treelist">
                        <GridPreview theme={theme} glob={glob} />
                    </div>
                </div>
            </div>
        </div>
    ];
}

